import { Component, Input, inject, ChangeDetectionStrategy } from '@angular/core';
import { HisAuthService } from '../../../auth/service/his-auth.service';

@Component( {
    selector: 'his-documentation-link',
    templateUrl: './his-documentation-link.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class HisDocumentationLinkComponent {
    auth = inject(HisAuthService);

    @Input() target: string;
    @Input() title: string = 'de.his.portal.doku';
}
